import React from 'react'
import PropTypes from "prop-types";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ListItemText} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";

function JobListItem(props) {

    return (
        <ListItem alignItems="flex-start">
            <ListItemIcon>
                <FontAwesomeIcon fixedWidth={true} icon={["far", "check"]} />
            </ListItemIcon>
            <ListItemText
                primary={props.text}
                primaryTypographyProps={{color: "secondary"}}
            />
        </ListItem>
    )
}

JobListItem.propTypes = {
    text: PropTypes.string,
};

export default JobListItem;
